import {
	SESSION_FETCH_SUCCESS,
	WORKSPACE_VALIDATE,
	WORKSPACE_VALIDATE_SUCCESS,
	WORKSPACE_VALIDATE_FAIL,
	WORKSPACE_ADD,
	WORKSPACE_ADD_SUCCESS,
	WORKSPACE_ADD_FAIL,
	WORKSPACE_UPDATE,
	WORKSPACE_UPDATE_SUCCESS,
	WORKSPACE_UPDATE_FAIL,
	WORKSPACE_DELETE,
	WORKSPACE_DELETE_SUCCESS,
	WORKSPACE_DELETE_FAIL,
	COMPANIES_REMOVE_SUCCESS,
	SOCKET_SUBSCRIBE,
	REQUEST_FINISHED
} from './actions';
import { showQuickMessage } from 'redux/modules/quickMessages';
import { setItem } from '../../storage';
import { omit } from 'lodash';

const initialState = {
	byId: null,
	allIds: null,
	rawDataById: null,
	valid: false,
	loading: false
};

// Company ID may be passes as a workspace prop (from socket) or as a second argument (from session)
const getWorkspace = (workspace, companyId) => {
	const { _id: id, ...props } = workspace;
	return { id, companyId, ...props };
};

const getState = companies => {
	let byId = {};
	let rawDataById = {};
	let allIds = [];

	for (const company of companies) {
		for (const workspace of company.workspaces) {
			const { id, ...props } = getWorkspace(workspace, company._id);
			allIds.push(id);
			byId[id] = { id, ...props };
			rawDataById[id] = { id, ...props };
		}
	}

	return { byId, allIds, rawDataById };
};

export default (state = initialState, action) => {

	switch (action.type) {

		case SESSION_FETCH_SUCCESS:
			return {
				...state,
				...getState(action.result.companies)
			};

		case WORKSPACE_ADD:
		case WORKSPACE_UPDATE:
		case WORKSPACE_DELETE:
			return {
				...state,
				loading: true
			};

		case WORKSPACE_VALIDATE:
			return {
				...state,
				loading: true,
				valid: false
			};

		case WORKSPACE_VALIDATE_SUCCESS:
			return {
				...state,
				loading: false,
				valid: true
			};

		case WORKSPACE_VALIDATE_FAIL:
			return {
				...state,
				loading: false,
				valid: false
			};

		case WORKSPACE_ADD_SUCCESS:
			setItem('selectedWorkspace', action.result._id);
			return {
				...state,
				allIds: [
					...state.allIds,
					action.result._id
				],
				byId: {
					...state.byId,
					[action.result._id]: getWorkspace(action.result)
				},
				rawDataById: {
					...state.rawDataById,
					[action.result._id]: getWorkspace(action.result)
				},				
				loading: false
			};

		case WORKSPACE_UPDATE_SUCCESS:
			return {
				...state,
				byId: {
					...state.byId,
					...{
						[action.payload.id]: {
							...state.byId[action.payload.id],
							...action.payload.data
						}
					}
				},
				rawDataById: {
					...state.rawDataById,
					...{
						[action.payload.id]: {
							...state.rawDataById[action.payload.id],
							...action.payload.data
						}
					}
				},				
				loading: false,
				valid: true
			};

		case WORKSPACE_DELETE_SUCCESS: {
			const workspaceId = action.result;
			return {
				...state,
				allIds: state.allIds.filter(id => id !== workspaceId),
				byId: omit(state.byId, workspaceId),
				rawDataById: omit(state.rawDataById, workspaceId),
				loading: false
			};
		}

		case REQUEST_FINISHED:
		case WORKSPACE_ADD_FAIL:
		case WORKSPACE_UPDATE_FAIL:
		case WORKSPACE_DELETE_FAIL:
			return {
				...state,
				loading: false
			};

		case COMPANIES_REMOVE_SUCCESS: {
			const companyId = action.result;
			const workspacesIdToRemove = state.allIds.filter(workspaceId => {
				const workspace = state.rawDataById[workspaceId];
				return workspace.companyId === companyId;
			});

			return {
				...state,
				allIds: state.allIds.filter(id => workspacesIdToRemove.indexOf(id) === -1),
				byId: omit(state.byId, workspacesIdToRemove),
				rawDataById: omit(state.rawDataById, workspacesIdToRemove),
			};
		}

		default:
			return state;
	}

};

// WORKSPACES

export const addWorkspace = (name, description) => {
	return (dispatch, getState) => {
		const { companies } = getState();
		return dispatch({
			types: [WORKSPACE_ADD, REQUEST_FINISHED, WORKSPACE_ADD_FAIL],
			promise: client => client.post('/workspaces', {
				data: { id: companies.selectedId, name, description }
			})
		});
	};
};

export const updateWorkspace = (id, data) => {
	return (dispatch) => {
		return dispatch({
			types: [WORKSPACE_UPDATE, REQUEST_FINISHED, WORKSPACE_UPDATE_FAIL],
			payload: { id, data },
			promise: client => client.patch(`/workspaces/${id}`, {
				data: { data }
			})
		});
	};
};

export const deleteWorkspace = (id) => {
	return dispatch => {
		return dispatch({
			types: [WORKSPACE_DELETE, REQUEST_FINISHED, WORKSPACE_DELETE_FAIL],
			payload: { id },
			promise: client => client.delete(`/workspaces/${id}`)
		});

	};
};

export const validateWorkspace = (companyId, name) => {
	return (dispatch, getState) => {
		const { companies } = getState();
		return dispatch({
			types: [WORKSPACE_VALIDATE, WORKSPACE_VALIDATE_SUCCESS, WORKSPACE_VALIDATE_FAIL],
			promise: client => client.get('/workspaces/validation', {
				params: {
					id: companyId || companies.selectedId,
					name
				}
			})
		});
	};

};

// SOCKET EVENTS

export const connectWorkspacesSocketEvents = () => {
	return dispatch => {

		dispatch({
			type: SOCKET_SUBSCRIBE,
			event: 'company:workspace:added',
			callback: WORKSPACE_ADD_SUCCESS
		});

		dispatch({
			type: SOCKET_SUBSCRIBE,
			event: 'company:workspace:updated',
			callback: payload => {
				dispatch({
					type: WORKSPACE_UPDATE_SUCCESS,
					payload: {
						id: payload._id,
						data: getWorkspace(payload)
					}
				});
				showQuickMessage('Changes were saved').call(this, dispatch);
			}
		});

		dispatch({
			type: SOCKET_SUBSCRIBE,
			event: 'company:workspace:removed',
			callback: WORKSPACE_DELETE_SUCCESS
		});

	};
};



// WEBPACK FOOTER //
// ./src/redux/modules/workspaces.js